const route = "/reports";

const parseExcel = `${route}/parse`;

const generateReport = `${route}/generate`;

const generateZips = `${route}/zip`;

export { route, parseExcel, generateReport, generateZips };
